<template>
  <!-- eslint-disable -->
  <div class="container-fluid">
    <div class="row header">
      <div class="col-lg-10 offset-lg-1 col-xl-8 offset-xl-2">
        <p class="dg-header-label">utilities</p>
        <h1 class="dg-header">Print</h1>
        <p>Quickly and easily hide and show elements for print.</p>
      </div>
    </div>

    <div class="row content">
      <div class="col-lg-10 offset-lg-1 col-xl-8 offset-xl-2">
        <!-- Content -->
        <div class="row">
          <div class="col">
            <p class="h3 dg-subheader">Code</p>
            <pre class="code-sample">
              <code class="html">&lt;!-- Screen only, do not print --&gt;
&lt;div class="d-print-none"&gt; ... &lt;/div&gt;

&lt;!-- Print Only, hide on screen --&gt;
&lt;div class="d-none d-print-block"&gt; ... &lt;/div&gt;

&lt;!-- Hide up to large on screen, but always show on print --&gt;
&lt;div class="d-none d-lg-block d-print-block"&gt; ... &lt;/div&gt;</code>
            </pre>
          </div>
        </div>
        <div class="row mt-4">
          <div class="col">
            <p class="h3 dg-subheader">Variants / Modifiers</p>
            <p>Print display utility classes that apply to all breakpoints.</p>
            <p><span class="var-sample">.d-print-{value}</span></p>
            <p>Where value is one of:</p>
            <ul>
              <li class="var-sample mb-2">none</li>
              <li class="var-sample mb-2">inline</li>
              <li class="var-sample mb-2">inline-block</li>
              <li class="var-sample mb-2">block</li>
              <li class="var-sample mb-2">table</li>
              <li class="var-sample mb-2">table-cell</li>
              <li class="var-sample mb-2">table-row</li>
              <li class="var-sample mb-2">flex</li>
              <li class="var-sample mb-2">inline-flex</li>
            </ul>
          </div>
        </div>
        <!-- Content End -->
      </div>
    </div>  
  </div>
  <!-- eslint-enable -->
</template>

<script>
export default {
  name: "Clearfix"
};
</script>

/* esling-disable */
<style lang="sass?outputStyle=expanded">
</style>
/* eslint-enable */



// WEBPACK FOOTER //
// src/components/routes/Print.vue